<template>
  <el-dialog
    class="sign-pad-dialog"
    width="728px"
    :title="title"
    :visible="signPadVisible"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    @opened="opened"
    @close="$emit('close')"
  >
    <div class="sign-wrap">
      <div class="cell">
        <div class="label">签名</div>
        <div class="value" @click="resign">
          <i class="el-icon-edit"></i>
          重签
        </div>
      </div>
      <div class="sign-pad" @mousedown="sign" @click="sign">
        <img class="origin-img" v-show="completeSignUrl && !needResign" :src="`//${completeSignUrl}`" alt="" />
        <div class="placeholder" v-show="isEmpty">请在此处输入签名</div>
        <VueSignaturePad style="border: 1px solid #d9d9d9" width="100%" height="195px" ref="signaturePad" />
      </div>
    </div>
    <template #footer>
      <div>
        <el-button size="small" @click="$emit('close')">取消</el-button>
        <el-button type="primary" size="small" @click="submit">{{ btnText }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

export default {
  name: 'signPad',
  props: {
    title: {
      type: String,
      default: ''
    },
    signPadVisible: {
      type: Boolean,
      default: false
    },
    completeSignUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isEmpty: false,
      needResign: false
    };
  },
  computed: {
    btnText() {
      return this.isEmpty ? '提交' : '确认';
    }
  },
  methods: {
    sign() {
      this.isEmpty = false;
    },
    resign() {
      this.$refs.signaturePad.clearSignature();
      this.$refs.signaturePad.openSignaturePad();
      this.isEmpty = true;
      this.needResign = true;
    },
    submit() {
      const { completeSignUrl, needResign } = this;

      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (completeSignUrl && !needResign) {
        this.$emit('submit', null);
      } else if (!isEmpty) {
        const signImg = data.replace('data:image/png;base64,', '');
        if (signImg !== 'data:,') {
          this.$emit('submit', signImg);
        } else {
          this.$message.info('签名不正确，请重签');
          Telescope.trackEvent({
            trackId: 'zywzpc-signPad',
            custom: { img: signImg, completeSignUrl: this.completeSignUrl }
          });
        }
      } else {
        this.$message.info('请签名');
      }
    },
    async opened() {
      const { completeSignUrl } = this;

      this.$refs.signaturePad?.clearSignature();

      Telescope.trackEvent({
        trackId: 'zywzpc-signPad-opened',
        custom: { completeSignUrl: this.completeSignUrl }
      });

      if (completeSignUrl) {
        this.isEmpty = false;
        this.needResign = false;
      } else {
        this.isEmpty = true;
        this.$refs.signaturePad.openSignaturePad();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-pad-dialog {
  /deep/.el-dialog {
    border-radius: unset;
  }

  /deep/.el-dialog__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    height: 56px;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #eee;
    }

    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      position: unset;
      display: unset;
    }
  }

  /deep/.el-dialog__body {
    position: relative;
    padding: 24px;
  }

  /deep/.el-dialog__footer {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 24px;
    height: 52px;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background-color: #eee;
    }

    .el-button {
      width: unset;
      height: unset;
      &.el-button--default {
        background-color: unset;
        border: 1px solid #dcdfe6;
      }
    }
  }

  .sign-wrap {
    .cell {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      .label {
        position: relative;
        font-size: 14px;
        color: #262626;

        &:after {
          content: '*';
          position: absolute;
          left: -8px;
          top: 0;
          color: #f56c6c;
        }
      }

      .value {
        font-size: 14px;
        color: #1e8dff;
        cursor: pointer;
      }
    }

    .sign-pad {
      position: relative;

      .origin-img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        pointer-events: none;
        font-size: 14px;
        color: #d9d9d9;
      }

      .placeholder {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        pointer-events: none;
        font-size: 14px;
        color: #d9d9d9;
      }
    }
  }
}
</style>
